import React, { useEffect, useState } from "react";
import "../../assets/styles/local/DashBoard.css";
import user from "../../assets/icons/grey-user.svg";
import mapPin from "../../assets/icons/map-pin.svg";
import mapPinDark from "../../assets/icons/map-pinDark.svg";
import { useDispatch, useSelector } from "react-redux";
import { CurrentWeekProjects } from "../../redux/actions/action";
import {
  setDefaults,
  fromAddress,
} from "react-geocode";
import { GoogleMap, Marker, useJsApiLoader, } from "@react-google-maps/api";

// This sets default values for language and region for geocoding requests.
setDefaults({
  key: "AIzaSyBcYRPNB_ePlSHVxC1p5buVrxdL_Uou_bc", // Your API key here from GooglePlacesAutocomplete.
  language: "en", // Default language for responses.
  region: "es", // Default region for responses.
});

const containerStyle = {
  height: "16rem",
  width: "23.375rem",
};

const MapCard = () => {
  const dispatch = useDispatch();
  const [weeklyProjects, setWeeklyProjects] = useState([]);
  const [mapCenter, setMapCenter] = useState({ lat: 52.1326, lng: 5.2913 })
  const projectsByWeek = useSelector((state) => state.user.projectsByWeek);
  const [hoveredProject, setHoveredProject] = useState(null);

  useEffect(() => {
    dispatch(CurrentWeekProjects());
  }, []);

  useEffect(() => {
    if (projectsByWeek.status) {
      fetchLocationAndMapData(projectsByWeek.data);
    }
  }, [projectsByWeek]);

  const fetchLocationAndMapData = async (response) => {
    if (response && Array.isArray(response)) {
      let filtered = response.filter(x => Boolean(x.projectaddress));
      for (let index = 0; index < filtered.length; index++) {
        const item = filtered[index];
        let address = await fromAddress(item.projectaddress);
        if (address.status == "OK") {
          filtered[index].location = address.results[0].geometry.location;
        }
      }
      let firstLocation = filtered.filter(x => Boolean(x.location));
      if (firstLocation.length > 0) {
        setMapCenter({ lat: firstLocation[0].location.lat, lng: firstLocation[0].location.lng })
      }
      setWeeklyProjects(filtered);
    }
  }

  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: "AIzaSyDAT6edaAWMoq7JjvbQaHbrJpkIiRC1Z0Y",
  });

  return (
    <>
      <div className="mapCard mapCard_Res" id="map">
        {isLoaded && (
          <GoogleMap mapContainerStyle={containerStyle} zoom={7} center={mapCenter}>
            {weeklyProjects.map((item, index) => <MapMarker item={item} index={index} onHover={setHoveredProject} />)}
          </GoogleMap>
        )}
      </div>
      {Boolean(hoveredProject) && <CustomMapCard item={hoveredProject} />}
    </>
  );
};

const MapMarker = ({ item, index, onHover }) => {
  return (
    <>
      <Marker
        key={`map-marker-${index}`}
        position={item.location}
        options={{ icon: mapPinDark }}
        onMouseOver={() => onHover(item)}
        onMouseOut={() => onHover(null)}
      />
    </>
  )
}

const CustomMapCard = ({ item }) => {
  return (
    <div className="info-card" key={`map-marker-card-${item.projectid}`}>
      <div className="content">
        <p className="d-flex">
          <span>
            <img src={mapPin} alt="" />
          </span>
          {item?.projectaddress}
        </p>
        <p>
          <span className="user">
            <img src={user} alt="" />
          </span>
          {item?.projectname}
        </p>
        <p>{item?.projectmanagername}</p>
        <p>{item?.projectmanagerphno}</p>
        <div className="dashed-line"></div>

        <div className="equipsDiv ps-3">
          {item?.equipmentid?.slice(0, 3).map((equip, equipIndex) => {
            let first_Name = equip.equipmentname.split("")[0].toUpperCase();
            let last_Name = equip.equipmentname
              .split(" ")[1]
              ?.slice(0, 1)
              .toUpperCase();

            return (
              <div key={equipIndex}>
                {equip.equipmentimages ? (
                  <img
                    src={equip.equipmentimages}
                    alt=""
                    className="blue-bordered-image"
                  />
                ) : (
                  <div className="blue-bordered-abbr py-1">
                    <p>
                      {last_Name
                        ? first_Name + "" + last_Name
                        : equip?.equipmentname?.slice(0, 2)?.toUpperCase()}
                    </p>
                  </div>
                )}
              </div>
            );
          })}

          {item?.equipmentid?.length > 3 && (
            <div className="rounded-images-container">
              <div className="plus-blue-bordered-abbr py-1">
                <p> + {item?.equipmentid?.length - 3}</p>
              </div>
            </div>
          )}
        </div>

        {/* for Drivers below 👇 */}

        <div className="equipsDiv pt-3 pe-4">
          {item?.equipmentid?.slice(0, 3).map((equip, equipIndex) => {
            let Driver_First_Name = equip?.drivername
              ?.split("")[0]
              ?.toUpperCase();
            let Driver_Last_Name = equip?.drivername
              ?.split(" ")[1]
              ?.slice(0, 1)
              .toUpperCase();
            return (
              <div key={equipIndex}>
                <div className="rounded-images-container">
                  {equip.equipmentdriverimage ? (
                    <img
                      src={equip.equipmentdriverimage}
                      alt=""
                      className="rounded-image"
                    />
                  ) : (
                    <div className="rounded-image-abr py-1">
                      <p>
                        {Driver_Last_Name
                          ? Driver_First_Name + "" + Driver_Last_Name
                          : equip.drivername?.slice(0, 2)?.toUpperCase()}
                      </p>
                    </div>
                  )}
                </div>
              </div>
            );
          })}

          {item?.equipmentid?.length > 3 && (
            <div className="rounded-images-container">
              <div className="plus-rounded-image-abr py-1">
                <p> + {item?.equipmentid?.length - 3}</p>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MapCard;
